module.exports = __webpack_public_path__ + "static/header-0155aa2abf3e6451c1367222c492449f.jpg";